import {
  CardExpirationDateElement,
  CardExpirationDateElementProps,
  ICardExpirationDateElement,
} from '@basis-theory/react-elements'
import React, { forwardRef } from 'react'
import { styles } from './payment-form'

interface CardExpiryInputProps {
  id: string
  placeholder: string
  onChange: CardExpirationDateElementProps['onChange']
}

const CardExpiryInput = forwardRef<ICardExpirationDateElement, CardExpiryInputProps>(
  ({ id, placeholder, onChange }, ref) => (
    <div className="w-full rounded-md border border-input bg-transparent shadow-sm transition-colors focus-within:ring-1 focus-within:ring-ring px-2">
      <CardExpirationDateElement id={id} ref={ref} style={styles} placeholder={placeholder} onChange={onChange} />
    </div>
  ),
)

export default CardExpiryInput
